/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-get, ember/require-tagless-components, warp-drive/no-legacy-request-patterns */
import Component from '@ember/component';
import { tracked } from '@glimmer/tracking';
import EmberObject, { action } from '@ember/object';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import SlotStatus from '@linc-technologies/linced-common/enums/bookings/event-slot-status';
import {
  resolved,
  sortBy,
} from '@linc-technologies/linced-common/utils/arrays';

export default class SlotManager extends Component {
  @service
  heroApiSlots;

  @service
  store;

  @service
  toaster;

  @tracked
  allocations = null;
  event = null;
  @tracked
  slots = null;
  @tracked
  openingDialog = false;
  @tracked
  dialogOpen = false;
  @tracked
  chipDataMap = EmberObject.create({});

  // buildChipDataMap builds a map in the form:
  // [date][] = slot
  buildChipDataMap() {
    if (isEmpty(this.slots)) {
      return;
    }
    let slots = resolved(this.slots);
    let chipData = slots.reduce((chipData, slot) => {
      let date = slot.get('date');
      if (isEmpty(chipData[date])) {
        chipData[date] = [slot];
      } else {
        chipData[date].push(slot);
      }
      return chipData;
    }, EmberObject.create({}));
    Object.entries(chipData).forEach(([date, chips]) => {
      chipData[date] = sortBy(chips, 'time');
    });
    this.chipDataMap = chipData;
  }

  blockSlot(slot) {
    slot.set('inProgress', true);
    this.heroApiSlots
      .block(slot.get('id'))
      .then(() => {
        this.toaster.success('Slot blocked successfully!');
      })
      .catch(() => {
        this.toaster.error('Slot block failed!');
      })
      .finally(() => {
        slot.set('inProgress', false);
      });
  }

  unblockSlot(slot) {
    slot.set('inProgress', true);
    this.heroApiSlots
      .release(slot.get('id'))
      .then(() => {
        this.toaster.success('Slot unblocked successfully!');
      })
      .catch(() => {
        this.toaster.error('Slot unblock failed!');
      })
      .finally(() => {
        slot.set('inProgress', false);
      });
  }

  @action
  openDialog() {
    this.openingDialog = true;
    let eventId = this.get('event.id');
    hash({
      allocations: this.store.query('bookings/allocation', { eventId }),
      slots: this.store.query('bookings/slot', { eventId }),
    })
      .then((data) => {
        this.allocations = data.allocations;
        this.slots = data.slots;
        this.dialogOpen = true;
        this.buildChipDataMap();
      })
      .finally(() => {
        this.openingDialog = false;
      });
  }

  @action
  toggleSlot(slot) {
    if (slot.get('inProgress')) {
      return;
    }
    if (slot.get('status') === SlotStatus.AVAILABLE) {
      this.blockSlot(slot);
    } else {
      this.unblockSlot(slot);
    }
  }
}
